import { Theme, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { BoxWrapper, Button, Loader, RemoteSubmit } from 'components/Base';
import React, { useEffect, useState } from 'react';
import {
  Field,
  Form,
  getFormValues,
  InjectedFormProps,
  reduxForm
} from 'redux-form';
import { CustomerType } from 'store/modules/Customers/types';
import Fields from 'components/Fields';
import Router from 'components/Router/Router';
import ROUTES from 'consts/routes';
import CheckboxField from 'components/Fields/Checkbox/Checkbox';
import api from 'api';
import Axios from 'axios';
import { Notify } from 'utils';
import { connect } from 'react-redux';
import selectors from 'store/selectors';
import Icons from 'components/Icons';
import Warning from 'components/Charts/Utils/Warning';
import store from 'store/store';
import { setQuestions } from 'store/modules/CapacityForLoss/actions';
import axios from 'axios';

const { useHistory, useParams } = Router;
const { actions } = store;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btnContainer: {
      marginTop: '1rem',
      display: 'flex',
      justifyContent: 'space-between'
    },
    questionnareEmailModal: {
      padding: '1rem',
      transition: 'all 0.3s ease-in-out',
      overflow: 'hidden',
      width: '550px',
      position: 'relative'
    },
    sendEmail: {
      marginBottom: '8px',
      animation: `$secondEmail 1000ms ${theme.transitions.easing.easeInOut}`
    },
    '@keyframes secondEmail': {
      '0%': {
        opacity: 0
      },
      '100%': {
        opacity: 1
      }
    },
    consolodateCheckbox: {
      fontSize: 'small',
      marginTop: '12px',
      marginBottom: '12px',
      marginLeft: '8px',
      alignSelf: 'end'
    },
    checkboxContainer: {
      position: 'absolute',
      bottom: '24px',
      animation: `$checkbox 1000ms ${theme.transitions.easing.easeInOut}`
    },
    '@keyframes checkbox': {
      '0%': {
        opacity: 0
      },
      '100%': {
        opacity: 1
      }
    },
    success: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    advisorEmail: {
      fontSize: '12px',
      color: '#9e9e9e'
    }
  })
);

interface QuestionnaireProps {
  customers: CustomerType[];
  onClose: Function;
  advisor?: any;
  createRiskProfile: Function;
  caseInfo: any;
  firmQuestionnaireLength: any;
  setCase: Function;
  setCustomersResponses: Function;
  firmRiskGroup: any;
}

enum OptionSets {
  optionSelect = 'optionSelect',
  advisorFill = 'advisorFill',
  clientFill = 'clientFill'
}

const QuestionnaireRequest = ({
  customers,
  onClose,
  advisor,
  handleSubmit,
  createRiskProfile,
  caseInfo,
  firmQuestionnaireLength,
  setCase,
  setCustomersResponses,
  firmRiskGroup
}: QuestionnaireProps & InjectedFormProps) => {
  const [optionSet, setOption] = useState(OptionSets.optionSelect);
  const classes = useStyles();
  const history = useHistory();
  const { portfolio } = useParams() as any;
  const [jointApplication, setJointApplication] = useState(false);
  const [includeCfl, setIncludeCfl] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formCustomer, setFormCustomers] = useState([] as CustomerType[]);
  const [successfullRequest, setSuccessfullRequest] = useState(false);
  const [showWarning, setShowwarning] = useState(
    caseInfo.questionnaireLength !== firmQuestionnaireLength ||
      caseInfo.riskGroup !== firmRiskGroup
  );
  const onSubmit = (values: any) => {
    setIsLoading(true);
    const isSingleCustomer = Object.values(values).length === 2;
    if (isSingleCustomer) {
      const request = {
        company_name: (advisor as any).organization.name,
        company_schema: (advisor as any).organization.schema,
        customer_id: customers[jointApplication ? 2 : 0].id,
        customer_email: values.customer_1,
        user_email: advisor.email,
        case_id: Number(portfolio),
        include_cfl: includeCfl
      };
      api
        .sendEmailQuestionnaire(request)
        .then(response => {
          if (response.status === 200) {
            setIsLoading(false);
            setSuccessfullRequest(true);
          }
        })
        .catch(() => {
          Notify.error(
            'Email request failed',
            'Please make sure the address is correct and try again'
          );
          setIsLoading(false);
          onClose();
        });
    } else {
      const request1 = {
        company_name: (advisor as any).organization.name,
        company_schema: (advisor as any).organization.schema,
        customer_id: customers[0].id,
        customer_email: values.customer_1,
        user_email: advisor.email,
        case_id: portfolio,
        include_cfl: includeCfl
      };
      const request2 = {
        company_name: (advisor as any).organization.name,
        company_schema: (advisor as any).organization.schema,
        customer_id: customers[1].id,
        customer_email: values.customer_2,
        user_email: advisor.email,
        case_id: portfolio,
        include_cfl: includeCfl
      };
      Axios.all([
        api.sendEmailQuestionnaire(request1),
        api.sendEmailQuestionnaire(request2)
      ])
        .then(() => {
          setIsLoading(false);
          setSuccessfullRequest(true);
        })
        .catch(() => {
          Notify.warn(
            'Email request failed',
            'Please make sure the addresses are correct and try again'
          );
          setIsLoading(false);
          onClose();
        });
    }
  };

  useEffect(() => {
    if (jointApplication && customers.length === 3) {
      const jointCustomer = customers[2];
      jointCustomer.display_name = '';
      return setFormCustomers([jointCustomer]);
    }
    if (!jointApplication && customers.length === 3) {
      return setFormCustomers([customers[0], customers[1]]);
    } else {
      return setFormCustomers([customers[0]]);
    }
  }, [jointApplication, customers]);

  const filteredCustomers = customers.filter(
    (customer: CustomerType) => !customer.is_jointed
  );
  const isMoreThanOneCustomer = filteredCustomers.length > 1;

  return (
    <BoxWrapper title="ATR Questionnaire" closeModal={onClose}>
      <div className={classes.questionnareEmailModal}>
        {showWarning && (
          <div style={{ marginBottom: '1rem' }}>
            <Warning
              noPadding
              text={
                <>
                  {caseInfo.riskProfiler !== 'EValue' ? (
                    <div>
                      This case was created using the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Morningstar 1-{caseInfo.questionnaireLength}
                      </span>{' '}
                      risk questionnaire, which differs from your firm's current
                      default of{' '}
                      <span style={{ fontWeight: 600 }}>
                        Morningstar 1-{firmQuestionnaireLength}
                      </span>
                      .
                    </div>
                  ) : (
                    <div>
                      This case was created using the{' '}
                      <span style={{ fontWeight: 600 }}>
                        1-{caseInfo.riskGroup}
                      </span>{' '}
                      risk questionnaire, which differs from your firm's current
                      default of{' '}
                      <span style={{ fontWeight: 600 }}>1-{firmRiskGroup}</span>
                      .
                    </div>
                  )}
                  <div style={{ marginTop: '0.5rem' }}>
                    If you switch to the current questionnaire, the original
                    responses will be lost. To preserve the existing data, we
                    recommend using the{' '}
                    <span style={{ fontWeight: 600 }}>'Clone'</span> or{' '}
                    <span style={{ fontWeight: 600 }}>'Follow-on'</span> options
                    on the{' '}
                    <span style={{ fontWeight: 600 }}>View All Cases</span> page
                    before making any changes.
                  </div>
                </>
              }
              buttonLabel="Use Default"
              onButtonClick={() => {
                setIsLoading(true);

                api
                  .editCase({
                    caseInfo: {
                      ...caseInfo,
                      questionnaire_length: firmQuestionnaireLength,
                      risk_group: firmRiskGroup
                    }
                  })
                  .then(response => {
                    setCase(response);

                    return axios.all([
                      api.getQuestionnares(),
                      ...customers.map((customer: CustomerType) =>
                        api.getCustomerQuestionnare({ customerId: customer.id })
                      )
                    ]);
                  })
                  .then(
                    axios.spread((questions, ...customerResponses) => {
                      setQuestions(questions.data);

                      const data: Record<string, any> = {};
                      customerResponses.forEach((res, index) => {
                        const result = res.data.results[0];
                        data[customers[index].id] = {
                          responses: result ? result.responses : [],
                          id: result ? result.id : null,
                          ...(result &&
                          result.risk_tolerance &&
                          !isMoreThanOneCustomer
                            ? { risk_tolerance: result.risk_tolerance }
                            : {})
                        };
                      });

                      setCustomersResponses(data);

                      setShowwarning(false);
                      setIsLoading(false);
                    })
                  );
              }}
            />
          </div>
        )}
        {!successfullRequest ? (
          <Loader isLoading={isLoading} size={30} isFixed={false}>
            {optionSet === OptionSets.clientFill ? (
              <Form onSubmit={handleSubmit(onSubmit)}>
                <CheckboxField
                  classes={{ label: classes.consolodateCheckbox }}
                  meta={{ touched: false, invalid: false, error: false }}
                  label={
                    caseInfo.riskProfiler === 'EValue'
                      ? 'Include Capacity for Loss questions'
                      : 'Include Experience Questionnaire'
                  }
                  fullWidth={false}
                  input={{
                    value: includeCfl,
                    onChange: () => setIncludeCfl(!includeCfl),
                    checked: includeCfl,
                    className: classes.consolodateCheckbox
                  }}
                />

                {formCustomer.map((customer: CustomerType, index: number) => {
                  return (
                    <Field
                      key={`name_${index + 1}`}
                      className={classes.sendEmail}
                      name={`customer_${index + 1}`}
                      component={Fields.Text}
                      validate={[
                        Fields.Validators.isValidEmail,
                        Fields.Validators.required
                      ]}
                      label={`${customer.display_name} Email`}
                      style={{ width: '100%' }}
                    />
                  );
                })}

                {customers.length === 3 && (
                  <CheckboxField
                    classes={{ label: classes.consolodateCheckbox }}
                    meta={{ touched: false, invalid: false, error: false }}
                    label={'Joint questionnaire'}
                    fullWidth={false}
                    input={{
                      value: jointApplication,
                      onChange: () => setJointApplication(!jointApplication),
                      checked: jointApplication,
                      className: classes.consolodateCheckbox
                    }}
                  />
                )}
                <Typography component="p" className={classes.advisorEmail}>
                  A copy of this email will be sent to {advisor.email}
                </Typography>
                <div className={classes.btnContainer}>
                  <Button
                    key="cancel"
                    color="primary"
                    onClick={() => onClose()}
                  >
                    Cancel
                  </Button>
                  <div>
                    <RemoteSubmit
                      key="Next"
                      isLoading={isLoading}
                      formName="emailForm"
                      id="emailForm"
                      color={'secondary'}
                    >
                      {formCustomer.length === 1 ? 'Send Email' : 'Send Emails'}
                    </RemoteSubmit>
                  </div>
                </div>
              </Form>
            ) : (
              <div className={classes.btnContainer} style={{ marginTop: '0' }}>
                <Button color="primary" onClick={() => onClose()}>
                  Cancel
                </Button>
                <div>
                  <Button
                    onClick={async () => {
                      await createRiskProfile();
                      history.push(`/${portfolio}${ROUTES.QUESTIONNAIRE.BASE}`);
                    }}
                    style={{ marginRight: '0.5rem' }}
                  >
                    View Questionnaire
                  </Button>
                  <Button onClick={() => setOption(OptionSets.clientFill)}>
                    Email Questionnaire
                  </Button>
                </div>
              </div>
            )}
          </Loader>
        ) : (
          <div className={classes.success}>
            <h4>Invitation sent successfully</h4>
            <Icons.Success topMargin="0px" height={'50px'} />
            <div style={{ marginTop: '24px' }}>
              <Button color="primary" onClick={() => onClose()}>
                Close
              </Button>
            </div>
          </div>
        )}
      </div>
    </BoxWrapper>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapStateToProps = (state: any, props: any) => ({
  initialValues: {
    advisor_email: state.advisor.advisor.email
  },
  advisor: selectors.advisorSelectors.getAdvisor(state),
  values: getFormValues('emailForm')(state),
  caseInfo: selectors.caseSelectors.case(state),
  firmQuestionnaireLength: selectors.firmSelectors.questionnaireLength(state),
  firmRiskGroup: selectors.firmSelectors.riskGroup(state)
});

export default connect(mapStateToProps, {
  setCase: actions.caseActions.setCaseInfo,
  setCustomersResponses: actions.questionnareActions.setCustomersResponses
})(
  reduxForm({
    form: 'emailForm',
    enableReinitialize: true
  })(QuestionnaireRequest)
);
